import axios from "axios";

// initial state
const state = {
  holidays: {},
  holidaysCount: 0
};

const getters = {
  getHolidays: state => state.holidays,
  getHolidaysCount: state => state.holidaysCount,
};

const mutations = {
  ['UPDATE_HOLIDAYS'](state, payload) {
    state.holidays = payload.data;
    state.holidaysCount = payload.count
  },
};
const actions = {
  ['GET_HOLIDAYS'](context) {
    let currentYear = new Date().getFullYear();
    // Fetch this year and the next, so a date range that straddles the
    // year end (e.g. a two-week export window starting in late December)
    // still resolves January's holidays. A year that fails to load just
    // contributes nothing instead of breaking the whole set.
    let years = [currentYear, currentYear + 1];

    Promise.all(
      years.map(year =>
        axios
          .get("https://feiertage-api.de/api/?jahr=" + year + "&nur_land=BY")
          .then(response => response.data)
          .catch(error => {
            window.app.$helpers.logger(error);
            return {};
          })
      )
    ).then(
      (yearlyHolidays => {
        // The API keys each holiday by name, which collides across years
        // (every year has a "Neujahrstag"), so re-key by date - dates are
        // unique and every consumer only reads `.datum`.
        let byDate = {};
        yearlyHolidays.forEach(holidays => {
          Object.keys(holidays).forEach(name => {
            let holiday = holidays[name];
            if (holiday && holiday.datum) {
              byDate[holiday.datum] = Object.assign({ name: name }, holiday);
            }
          });
        });

        context.commit('UPDATE_HOLIDAYS', {
          count: Object.keys(byDate).length,
          data: byDate
        });
      }).bind(this)
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
